<mat-card class="login-card">
  <mat-card-header>
    <mat-card-title class="mat-headline-4 login-card-title pt-20-i pl-10">{{ title }}</mat-card-title>
    <mat-card-subtitle class="pb-10-i pl-10">{{ subtitle }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <ng-content select="[card-content]"></ng-content>
  </mat-card-content>
  <mat-card-actions>
    <div class="fx-row-w-100 p-10">
      <ng-content select="[card-actions]"></ng-content>
    </div>
  </mat-card-actions>
</mat-card>
